import React from 'react';

import { AVAILABLE_TAG_ICONS } from 'components/ObjectiveTagList/TagIcon';
import styled, { css } from 'styled-components';
import { StyledBox, StyledGrid } from 'styles/common';

import { OBJECTIVE_LEVEL_TAGS } from 'constants/ProjectConstants';
import { ObjectiveTwoToneSvgIcon } from 'constants/icons';
import theme from 'constants/theme';

import { Typography13, Typography14 } from 'uiToolkit/Typography';

import { DownLine, Tline } from '../../../analytics/commonComponents';

const OBJECTIVE_LEVEL_TAGS_MAP = OBJECTIVE_LEVEL_TAGS.reduce((prev, curr) => ({ ...prev, [curr.value]: curr }), {});

const ObjectiveRow = ({ index, name, objectiveLevel, levelsForWhichLinesToBeDrawn, level, isLast = false }) => {
  const isExpandedDerived = true; //

  return (
    <Container $indent={index} $isLast={isLast} id="tum-tak">
      <StyledBox flex="0 0 auto" marginTop="4px">
        {/* {index !== 0 ? (
          <SubDirectorySvgIcon size="fixed18px" color="#27313F" rightGutter={2} />
        ) : null} */}
        <ObjectiveTwoToneSvgIcon size="fixed18px" color="#BB6BD9" />
        {!isLast && <DownLine level={1} inMeshList index={index} />}
        {index > 0 && <Tline half level={1} inMeshList index={index} />}
      </StyledBox>
      <StyledBox leftGutter={2}>
        <Typography14 bottomGutter={1.5} id="naam" overflow="hidden" display="-webkit-box" lineClamp="2">
          {name}
        </Typography14>
        {OBJECTIVE_LEVEL_TAGS_MAP[objectiveLevel] ? (
          <StyledGrid container alignItems="center">
            {AVAILABLE_TAG_ICONS[OBJECTIVE_LEVEL_TAGS_MAP[objectiveLevel].value]}
            <Typography13 color={theme.palette.grey.dark} leftGutter={1}>
              {OBJECTIVE_LEVEL_TAGS_MAP[objectiveLevel]?.label}
            </Typography13>
          </StyledGrid>
        ) : null}
      </StyledBox>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  padding: 16px;
  cursor: pointer;
  position: relative;

  ${(props) => props.$indent > 0 && `padding-left: ${16 + props.$indent * 34}px`};
  ${(props) =>
    props.$isLast &&
    css`
      background-color: ${theme.palette.background.lightBlue};
    `}

  &:hover {
    background-color: ${theme.palette.background.lightBlue};
  }
`;

export default ObjectiveRow;
